import { Filter } from '../types/filter';
import { FilterConfig } from '../types/filter-config';

/**
 * Drops filter nodes whose field no longer exists in the config (stale templates)
 * and collapses condition groups left with a single child. Never throws.
 */
export function validateFilterTemplateValue<T extends object>(
  filter: Filter<T> | null,
  config: FilterConfig<T>
): Filter<T> | null {
  if (!filter) return null;
  if (filter.type === 'conditions') {
    const filters = filter.filters
      .map((o) => validateFilterTemplateValue(o, config))
      .filter((o): o is Filter<T> => o !== null);
    if (filters.length === 0) return null;
    if (filters.length === 1) return filters[0];
    return { ...filter, filters };
  }
  const item = config.items.find((o) => o.field === filter.field);
  return item ? filter : null;
}
